import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
import { mapDEPBResponse } from "@/redux/mappers/Export/CreateNewJob/DEPBMapper";
export const exportProductEPCGApi = createApi({
  reducerPath: "productEPCGApi",
  baseQuery,
  tagTypes: ["productEPCG"],
  endpoints: (builder) => ({
    getProductEPCGTableOne: builder.query({
      query: ({ id }) => `/export/product/epcg/${id}`,
      transformResponse: (response) => {
        return response?.data?.map((item,idx)=>{
          return {
            ...item,
            srNo: idx + 1,
            id: item.exportProductEPCGId,
          }
        }) ?? [];
      },
      providesTags: ["productEPCG"],
    }),

    createProductEPCGTableOne: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/export/product/epcg/${id}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { exportProductEPCG: data },
      }),
      invalidatesTags: ["productEPCG"],
    }),

    updateProductEPCGTableOne: builder.mutation({
      query: ({ id,subId, ...data }) => ({
        url: `/export/product/epcg/${id}/${subId}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { exportProductEPCG: data },
      }),
      invalidatesTags: ["productEPCG"],
    }),

    deleteProductEPCGTableOne: builder.mutation({
      query: ({ id }) => ({
        url: `/export/product/epcg/${id}`,
        method: "DELETE",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
      }),
      invalidatesTags: ["productEPCG"],
    }),
      createProductEPCGTableTwo: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/export/product/epcg/item/${id}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { exportproductEPCGItem: data },
      }),
      invalidatesTags: ["productEPCG"],
    }),

    updateProductEPCGTableTwo: builder.mutation({
      query: ({ id, subId, ...data }) => ({
        url: `/export/product/epcg/item/${id}/${subId}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { exportproductEPCGItem: data },
      }),
      invalidatesTags: ["productEPCG"],
    }),


    deleteProductEPCGTableTwo: builder.mutation({
      query: ({ id }) => ({
        url: `/export/product/epcg/item/${id}`,
        method: "DELETE",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
      }),
      invalidatesTags: ["productEPCG"],
    }),

    getProductEPCGTableTwo: builder.query({
      query: ({ id }) => `/export/product/epcg/item/${id}`,
      transformResponse: (response) => {
        const data = response?.data ?? [];
        const normalized = Array.isArray(data) ? data : [data];

        return normalized.map((item,idx) => ({
          ...item,
          srNo: idx + 1,
          id: item.exportProductEPCGItemId,
        }));
      },
      providesTags: ["productEPCG"],
    }),
  }),
});

export const {
  useLazyGetProductEPCGTableOneQuery,
  useCreateProductEPCGTableOneMutation,
  useUpdateProductEPCGTableOneMutation,
  useDeleteProductEPCGTableOneMutation,
  useCreateProductEPCGTableTwoMutation,
  useLazyGetProductEPCGTableTwoQuery,
  useUpdateProductEPCGTableTwoMutation,
  useDeleteProductEPCGTableTwoMutation,
} = exportProductEPCGApi;
